<template>
  <div>
    <HeaderSteps
      title="Edit campaign"
      :steps="type === 'simple' ? steps : []"
      :active="currentStep"
      :back-path="-1"
      @step="handlerStep"
    ></HeaderSteps>
    <template v-if="currentStep === 0">
      <CampaignDetails :type="type" @step="getCurrentStep" @change="onChange" ref="formDetails" />
    </template>
    <template v-if="currentStep === 1">
      <CampaignPeriod @step="getCurrentStep" @change="onChange" ref="formPeriod" />
    </template>
    <template v-if="currentStep === 2">
      <Assets />
    </template>
  </div>
</template>
<script>
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignDetails from '@/components/social-products/social-boost/forms/CampaignDetails.vue'
import CampaignPeriod from '@/components/social-products/social-boost/forms/PeriodBudget.vue'
import Assets from '@/components/social-products/social-boost/forms/Assets.vue'
import SocialBoostCampaignMixin from '@/mixins/social-products/social-boost-campaign'
import SocialBoostCampaignAutosaveMixin from '@/mixins/social-products/CampaignAutosave'

export default {
  name: 'CreateCampaign',
  mixins: [SocialBoostCampaignMixin, SocialBoostCampaignAutosaveMixin],
  components: {
    HeaderSteps,
    CampaignDetails,
    CampaignPeriod,
    Assets,
  },
  data() {
    return {
      steps: ['Campaign details', 'Period and budget', 'Assets'],
      currentStep: 0,
      hasUnsavedChanges: false,
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
  },
  async created() {
    // this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.$route.params.id })
    this.currentStep = this.$route?.query?.step ? Number(this.$route.query.step) : 0

    await this.updateStoreFormDetails(true)
  },
  methods: {
    handlerStep(step) {
      this.currentStep = step
    },
    getCurrentStep(step) {
      this.currentStep = step
    },
  },
}
</script>
